<template>
    <div v-if="isLoading">
        <b-row>
            <b-col md="6">
                <atom-spinner
                    :animation-duration="1000"
                    :size="60"
                    color="#ff1d5e"
                    class="float-right my-5"
                />
            </b-col>
        </b-row>
    </div>
    <div v-else class="animated fadeIn pt-1">
        <b-row>
            <b-col md="12">
                <ul class="heading-ul">
                    <li>
                        <button size="sm" @click="backButton">
                            <i
                                class="fa fa-arrow-left font-size-18 text-dark-gray"
                                aria-hidden="false"
                            ></i>
                        </button>
                    </li>
                    <li><h4>Edit Feature</h4></li>
                </ul>
            </b-col>
        </b-row>
        <b-row>
            <b-col md="12">
                <b-card border-variant="info">
                    <b-row>
                        <b-col cols="12" sm="12" md="12">
                            <div class="form-group">
                                <b-form-input
                                    maxlength="100"
                                    placeholder="Enter Feature Name"
                                    v-model="getFeatureDetails.name"
                                ></b-form-input>
                            </div>
                        </b-col>
                        <b-col cols="12" sm="12" md="12">
                            <textarea
                                class="form-control w-95"
                                type="text"
                                rows="3"
                                placeholder="Enter Description"
                                v-model="getFeatureDetails.description"
                            />
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
       <b-row>
    <b-col cols="12" sm="12" md="6" class="d-flex align-items-center">
        <h4>Add Permission</h4>
    </b-col>
    <b-col cols="12" sm="12" md="4" class="d-flex align-items-center">
        <div class="form-group mt-2">
            <multiselect
                class="perm_input"
                :options="allPermissions"
                placeholder="Select a Permission"
                label="name"
                track-by="_id"
                :multiple="false"
                v-model="permission"
            ></multiselect>
        </div>
    </b-col>
    <b-col cols="12" sm="12" md="2" class="d-flex align-items-center">
        <div class="btnReload_Div">
            <b-button
                block
                size="lg"
                variant="primary"
                :disabled="permission == ''"
                @click="onClickAddPermission"
            >
                Add
            </b-button>
            <b-button
                size="lg"
                variant="success"
                @click="reloadData"
                :disabled="isLoading"
            >
                <span v-if="isLoading" class="fa fa-refresh fa-spin font-size-15" />
                <span v-else class="fa fa-refresh font-size-15" />
            </b-button>
        </div>
    </b-col>
</b-row>

        <b-row>
            <b-col md="12">
                <b-card border-variant="info">
                    <div>
                        <b-table
                            responsive
                            :items="tableData"
                            :fields="tableFields"
                            thead-class="header"
                            show-empty
                            :no-border-collapse="true"
                            :current-page="currentPage"
                            :per-page="perPage"
                            :filter="filter"
                            @filtered="onFilter"
                            :sort-by.sync="sortBy"
                            :sort-desc.sync="sortDesc"
                        >
                            <template slot="cell(empty)">
                                <div v-if="isLoading" class="text-center">
                                    <span><b>Loading...</b></span>
                                </div>
                                <div v-else class="text-center">
                                    No data available.
                                </div>
                            </template>
                            <template slot="cell(Action)" slot-scope="data">
                                <div class="d-flex">
                                    <div>
                                        <b-button
                                            size="sm"
                                            class="button-circle"
                                            variant="danger"
                                            @click="deleteTableItem(data.index)"
                                        >
                                            <i class="fa fa-trash"></i>
                                        </b-button>
                                    </div>
                                </div>
                            </template>
                        </b-table>
                    </div>
                    <div v-if="(filterCount || tableData.length) >= 10" class="pagination-wrapper">
                        <b-pagination
                            v-model="currentPage"
                            :per-page="perPage"
                            :total-rows="filterCount || tableData.length"
                            aria-controls="my-table"
                            prev-text="Prev"
                            next-text="Next"
                            hide-goto-end-buttons
                        ></b-pagination>
                    </div>
                </b-card>
            </b-col>
        </b-row>
        <b-row class="justify-content-center">
            <b-col md="12">
                <div class="cancelSaveBtn">
                    <b-button
                        variant="danger"
                        class="btn btn-danger btn-width-100"
                        @click="onClickClear"
                        >Cancel
                    </b-button>
                    <b-button
                        class="btn-width-100"
                        variant="primary"
                        @click="onClickUpdate"
                        >Update
                    </b-button>
                </div>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import { mapState } from "vuex";
import { AtomSpinner } from "epic-spinners";

export default {
    name: "features",
    props: {},
    components: {
        AtomSpinner,
    },
    data() {
        return {
            isLoading: false,
            permission: "",
            filterCount: 0,
            filter: "",
            sortBy: "createdAt",
            sortDesc: true,
            currentPage: 1,
            perPage: 10,
            tableFields: [
                {
                    label: "Resource",
                    key: "resource",
                },
                {
                    label: "Permission",
                    key: "name",
                },
                {
                    label: "Method",
                    key: "action",
                },
                {
                    label: "Action",
                    key: "Action",
                },
            ],
            tableData: [],
        };
    },
    computed: {
        ...mapState({
            allPermissions: (state) => state.permission.permissionList,
            getFeatureDetails: (state) => state.feature.featureDetails,
        }),
    },
    methods: {
        async reloadData() {
            this.isLoading = true;
            await this.$store.dispatch("permission/fetchAllPermission");
            this.isLoading = false;
        },
        onFilter(list) {
            this.filterCount = list.length;
            this.currentPage = 1;
        },
        onClickAddPermission() {
            const permissionExistsInTable = this.tableData.some(
                (perm) => perm._id === this.permission._id,
            );
            const permissionExistsInFeatureDetails =
                this.getFeatureDetails.permission.some(
                    (perm) => perm._id === this.permission._id,
                );
            if (permissionExistsInTable || permissionExistsInFeatureDetails) {
                this.$toasted.error("Permission Already Added!");
            } else {
                if (this.permission !== null) {
                    this.tableData.push(this.permission);
                    this.$toasted.success("Permission Added Successfully");
                } else {
                    this.$toasted.error("Please select a Permission");
                }
            }
        },
        backButton() {
            this.$router.push({ path: "/features" });
        },
        onClickClear() {
            this.isLoading = true;
            this.$swal({
                title: "",
                text: "You want to Cancel!",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#d33",
                cancelButtonColor: "#3085d6",
                confirmButtonText: "Yes, Cancel!",
                cancelButtonText: "No don't Cancel!",
                closeOnConfirm: false,
                closeOnCancel: false,
            }).then(async (result) => {
                if (result.value) {
                    this.$swal({
                        timer: 1100,
                        title: "Cancelled!",
                        text: "Yes, Cancelled.Please Update...",
                    });
                    this.isLoading = false;
                    this.$router.push({ path: "/features" });
                    this.tableData = [];
                    this.getFeatureDetails.name = "";
                    this.getFeatureDetails.description = "";
                }
            });
        },
        async onClickUpdate() {
            this.isLoading = true;
            let dataObj = {
                id: this.$route.params.id,
                data: {
                    name: this.getFeatureDetails.name,
                    description: this.getFeatureDetails.description,
                    permission: this.tableData,
                },
            };
            if (
                dataObj.data.name.length != 0 &&
                dataObj.data.permission.length != 0
            ) {
                await this.$store.dispatch("feature/updateFeature", dataObj);
                this.$swal({
                    title: "Success",
                    text: "Updated",
                    type: "success",
                    timer: 2000,
                });
                this.isLoading = false;
                this.$router.push({ path: "/features" });
            } else {
                this.$swal({
                    title: "Error",
                    text: "Please fill all required fields.",
                    type: "error",
                });
            }
            this.isLoading = false;
        },
        deleteTableItem(index) {
            this.$swal({
                title: "Are you sure?",
                text: "You want to delete this permission?",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#d33",
                cancelButtonColor: "#d33",
                confirmButtonText: "Delete",
                reverseButtons: true,
            })
                .then((result) => {
                    if (result.value) {
                        this.tableData.splice(index, 1);
                        this.$toasted.success(
                            "Permission Deleted Successfully",
                        );
                    }
                })
                .catch((error) => {
                    this.$toasted.error(error.message);
                });
        },
        selectedPermissions() {
            this.getFeatureDetails?.permission?.filter((permit) => {
                this.tableData.push(permit);
            });
        },
    },
    async mounted() {
        this.isLoading = true;
        await this.$store.dispatch("permission/fetchAllPermission");
        await this.$store.dispatch(
            "feature/fetchFeatureDetails",
            this.$route.params.id,
        );
        this.selectedPermissions();
        this.isLoading = false;
    },
};
</script>

<style>
.searchField {
    font-size: 12px;
    font-weight: 600;
    border-radius: 30px;
    padding: 17px;
    height: 36px;
}

tbody tr:nth-child(2n + 1) {
    border-bottom: 1px solid #e8e5e5;
}

.font-size-18 {
    font-size: 18px;
}

.text-dark-gray {
    color: rgb(38, 38, 38);
}

.font-size-15 {
    font-size: 15px;
}

.btn-width-100 {
    width: 100px;
}
</style>
